<p-dialog
  #fastCategoriaMP
  [modal]="true"
  [visible]="true"
  (visibleChange)="dialogRef.close()"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [maximizable]="true"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="false"
  [dismissableMask]="false"
>
  <ng-template pTemplate="header">
    <div class="flex aling-items-center">
      <span class="font-light fs-normal">
        Adicionar categoria de matéria prima
      </span>
      <i class="mdi mdi-shape-outline ml-2 text-primary"></i>
    </div>
  </ng-template>
  <div class="row p-2">
    <div class="col-md-12 mt-3">
      <span class="p-float-label">
        <input
          id="inputtext-nome"
          class="input-filters"
          pInputText
          [formControl]="form.get('descricao')"
          (blur)="actionFnCheckEntityExist(form.get('descricao'))"
          type="text"
          autocomplete="off"
        />
        <label for="inputtext-descricao">Descrição *</label>
      </span>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('duplicate')"
      >
        {{ displayMessage.descricao.duplicate }}
      </small>
      <small class="p-error" *ngIf="form.get('descricao').hasError('required')">
        {{ displayMessage.descricao.required }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('maxlength')"
      >
        {{ displayMessage.descricao.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="form.get('descricao').hasError('isEmptyValue')"
      >
        {{ displayMessage.descricao.isEmptyValue }}
      </small>
    </div>
    <div class="col-md-12 mt-3">
      <mat-form-field appearance="outline" class="width-100">
        <mat-label>Classificação</mat-label>
        <mat-select [formControl]="form.controls.classificacao">
          <mat-option *ngFor="let i of tipoClassificacao" [value]="i.value">
            {{ i.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          form.get('classificacao').touched &&
          form.get('classificacao').hasError('required')
        "
      >
        Classificação é obrigatória
      </small>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="width-100 mb-3 flex align-items-center justify-content-between">
      <button
        pButton
        pRipple
        severity="danger"
        text
        rounded
        (click)="dialogRef.close()"
        [disabled]="loading"
        label="Cancelar"
        icon="pi pi-fw pi-times-circle"
        iconPos="right"
      ></button>
      <button
        pButton
        pRipple
        severity="success"
        outlined
        rounded
        label="Salvar"
        icon="pi pi-fw pi-save"
        iconPos="right"
        (click)="onSubmit()"
        [disabled]="loading || !form.valid"
      ></button>
    </div>
  </ng-template>
</p-dialog>
